'use client';

import {FC} from 'react';
import {AccordionDetails, AccordionSummary, Container, Typography,} from '@mui/material';
import {RichTextRenderer} from '@/components/contentful/RichTextRenderer';
import {EmbeddedEntryPathProvider} from '@/components/contentful/RichTextRefsContext';
import {Document} from '@contentful/rich-text-types';
import {FaqSectionFieldsFragment} from '@generated/graphql';
import {FaqSectionContainer, StyledAccordion, StyledExpandMoreIcon} from './FaqSection.styles';

type FaqSectionProps = {
  section: FaqSectionFieldsFragment;
  embedded?: boolean;
};

export const FaqSection: FC<FaqSectionProps> = ({section, embedded}) => {
  const items = section.faqItemsCollection?.items ?? [];

  return (
    <EmbeddedEntryPathProvider entryId={section.sys.id}>
      <Container maxWidth={'md'} {...(section.id && {id: section.id})} disableGutters={embedded}>
        <FaqSectionContainer disableGutters={embedded} embedded={embedded}>
          {section.heading && (
            <Typography variant='h3' sx={{textAlign: 'left', mb: 4}}>
              {section.heading}
            </Typography>
          )}
          {items.map((item) => {
            if (!item) return null;
            return (
              <StyledAccordion key={item.sys.id} disableGutters elevation={0}>
                <AccordionSummary expandIcon={<StyledExpandMoreIcon />}>
                  <Typography variant='h4'>{item.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <RichTextRenderer richTextDocument={item.answer?.json as unknown as Document} />
                </AccordionDetails>
              </StyledAccordion>
            );
          })}
        </FaqSectionContainer>
      </Container>
    </EmbeddedEntryPathProvider>
  );
};
